import { render, staticRenderFns } from "./carCreateFeeAdd.vue?vue&type=template&id=5d7072db&scoped=true"
import script from "./carCreateFeeAdd.vue?vue&type=script&lang=js"
export * from "./carCreateFeeAdd.vue?vue&type=script&lang=js"
import style0 from "./carCreateFeeAdd.vue?vue&type=style&index=0&id=5d7072db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7072db",
  null
  
)

export default component.exports